import { Api } from '../api';
import { customer } from '../endpoints';
import type { ApplicationCustomerDetailsEntity, CustomerDataItem, CustomerEntity, CustomerSearchParams } from './models';

export class CustomerApi extends Api {
  static getCustomers = (searchParams: CustomerSearchParams = {}, signal?: AbortSignal) =>
    this.post<CustomerSearchParams, CustomerDataItem[]>({ url: customer.getCustomers(), data: searchParams, signal });

  static getCustomer = (customerId: string, signal?: AbortSignal) => this.get<CustomerEntity>({ url: customer.getCustomerCard(customerId), signal });

  static getCustomerApplicationDetails = (customerId: string, signal?: AbortSignal) =>
    this.get<ApplicationCustomerDetailsEntity>({ url: customer.getCustomerCard(customerId), signal });
}
